module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1019-50357db567a838941cf500d272b2b341.png";